import { Box, Flex, Image } from '@mantine/core'

import type { AccountItemProps } from '@/modules/accounts/components/AccountItem/AccountItem.types'

import { MoreDropdown } from '@/components/MoreDropdown/MoreDropdown'
import { Text } from '@/components/Text/Text'
import { Tooltip } from '@/components/Tooltip/Tooltip'

import { formatMoney } from '@/helpers/formatMoney.helper'
import { getCurrentBalanceType } from '@/helpers/getCurrentBalanceType.helper'

import classes from './AccountItem.module.css'

export function AccountItem({
  account,
  openDeleteModal,
  openEditModal,
}: AccountItemProps) {
  const currentBalance = getCurrentBalanceType(account.type, account.subtype)

  const moreItems = [
    {
      label: 'Delete',
      onClick: openDeleteModal,
      param: account.plaidId,
    },
  ]

  const moreItemsManual = [
    {
      label: 'Edit',
      onClick: openEditModal,
      param: account.plaidId,
    },
    {
      label: 'Delete',
      onClick: openDeleteModal,
      param: account.plaidId,
    },
  ]

  return (
    <Box className={classes.account}>
      <Flex align="center" justify="space-between">
        <Tooltip
          label={`${account.name}${account.institution?.name ? ` · ${account.institution.name}` : ''}`}
          withIcon={false}
        >
          <Text truncate="end" variant="body_3">
            {account.name}
          </Text>
        </Tooltip>

        <MoreDropdown items={!account.isManual ? moreItems : moreItemsManual} />
      </Flex>

      {account.mask && (
        <Text mt={22} variant="body_2_black">
          **** **** **** {account.mask}
        </Text>
      )}

      <Flex align="center" justify="space-between" mt={19}>
        {account.balance.isBalanceReady && (
          <Text variant="body_1_semibold">
            {formatMoney(
              account.balance[currentBalance],
              account.balance.currency,
            )}
          </Text>
        )}

        {!account.balance.isBalanceReady && (
          <Text variant="body_2">Balance available soon</Text>
        )}

        {account.logo && <Image alt={account.name} src={account.logo} w={32} />}
      </Flex>
    </Box>
  )
}
